export * from "./comp-rates.component";
